import { HrefSegment, HrefUtils } from '@technocom/common/http';
import { Entity, EntityKey, EntityPlainMapOf, EntityType } from '@technocom/data/core';
import { PlainObject } from '@technocom/common/platform';
import { Action } from '@app/core/profile/models/action';

export abstract class Endpoints {
  protected static _SEGMENT: string;

  static of(...args: Array<EndpointSegment>): string {
    return createEndpoint(...args);
  }

  static ofSegment(...args: Array<EndpointSegment>): string {
    return createEndpoint(this._SEGMENT, ...args);
  }

  static ofRegistration(...args: Array<EndpointSegment>): string {
    return this.ofPerson('registration', ...args);
  }

  static ofPerson(...args: Array<EndpointSegment>): string {
    return createEndpoint('person', ...args);
  }

  static ofPersonCabinet(...args: Array<EndpointSegment>): string {
    return this.ofPerson('cabinet', ...args);
  }

  static ofAction(...args: Array<EndpointSegment>): string {
    return this.ofPerson(Action, 'action', ...args);
  }
}

/**
 * [Копия из инвестпроект] Функция для создания ссылки на репозиторий модели.  *
 * - Если найден {@link EntityType}, то все параметры, следующие за ним,
 * передаются в вызов {@link EntityType.apiOf};
 * - {@link PlainObject} обязательно должны идти сразу после {@link EntityType},
 * иначе идентификатор модели не будет извлечён из объекта;
 * - Остальные значения подставляются "как есть".
 *
 * @example ```
 *   // /investment-project/1
 *   const a = createEndpoint(InvestProject, 1);
 *   const b = InvestProject.apiOf(1)
 *
 *   // /investment-project/1/common-mineral
 *   const c = createEndpoint(InvestProject, 1, CommonMineral);
 *   const d = InvestProject.apiOf(1, CommonMineral.getServerRoot())
 *
 *   // /investment-project/1/common-mineral/some-url
 *   const e = createEndpoint(InvestProject, 1, CommonMineral, '/some-url');
 *   const f = InvestProject.apiOf(1, CommonMineral.apiWith('/some-url'))
 * `
 */
export function createEndpoint(...args: Array<EndpointSegment>): string {
  let index = args.length;

  while (index > 0) {
    const value = args[--index];
    if (value instanceof Function) {
      const parts = args.splice(index + 1);
      const [modelKey, ...extra] = parts;

      args[index] = value.apiOf(modelKey, extra as HrefSegment[]);
    } else if (value instanceof Entity) {
      args[index] = value.id;
      // Добавил для вставки сегмента текста
    } else if (value instanceof String) {
      args[index] = value;
    }
  }

  return HrefUtils.join(args as HrefSegment[]);
}

export type EndpointSegment = EntityType | EntityKey | Entity | PlainObject | HrefSegment;

export type EndpointSegmentOf<T extends Entity> = EntityKey | EntityPlainMapOf<T>;
